/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnInit, TemplateRef } from '@angular/core';

/**
 * This class represents item rendered in the virtual viewport
 */
@Component({
  selector: 'gh-virtual-item',
  template: `
    <ng-container [ngTemplateOutlet]="template"
                  [ngTemplateOutletContext]="context"></ng-container>`,
  styles: [require('./virtual-item.component.scss')],
})
export class VirtualItemComponent implements OnInit {
  template: TemplateRef<any>;
  context: any;

  private _top: number;
  private _left: number;
  private _data: any;
  private transform: string;
  private initialized: boolean = false;

  @Input()
  set data(data: any) {
    this._data = data;
    this.updateContext();
    this.updatePosition();
  }

  get data(): any {
    return this._data;
  }

  @Input()
  set top(top: number) {
    if (this._top !== top) {
      this._top = top;
      this.transform = `translate3d(0, ${top}px, 0.1px)`;
      this.updatePosition();
    }
  }

  get top(): number {
    return this._top;
  }

  @Input()
  set left(left: number) {
    if (this._left !== left) {
      this._left = left;
      this.transform = `translate3d(${left}px, 0, 0.1px)`;
      this.updatePosition();
    }
  }

  get left(): number {
    return this._left;
  }

  constructor(private elementRef: ElementRef) {

  }

  ngOnInit(): void {
    this.initialized = true;
    this.updateContext();
    this.updatePosition();
  }

  private updateContext(): void {
    this.context = {
      $implicit: this.data,
    };
  }

  private updatePosition(): void {
    if (this.initialized) {
      this.elementRef.nativeElement.style.transform = this.transform;
    }
  }
}
